/* global window */
let authInfo;
const init = data => {
  authInfo = {};
  authInfo.access_token = data.access_token;
  authInfo.expires_in = data.expires_in; // seconds
  authInfo.user_name = data.user_name;
  authInfo.group_id = data.group_id;
  authInfo.rol_id = data.rol_id;
  authInfo.user_id = data.user_id;
  authInfo.company_id = data.company_id;
  authInfo.company_name = data.company_name;
  authInfo.time_zone = data.time_zone;
  authInfo.currency = data.currency;
  authInfo.companies = data.companies;
  authInfo.companiesByGroup = data.companiesByGroup;
  authInfo.creation_time = new Date().getTime(); // ms
};
const now = () => new Date().getTime();
const LOCAL_STORAGE_KEY = 'authInfo';
const DEFAULT_TIMEZONE = 'Europe/Madrid';
const DEFAULT_CURRENCY = {
  iso: 'EUR',
  simbol: '\u20ac',
};

export default (options = {}) => {
  const ls = options.localStorage || window.localStorage;
  return {
    localStorageKey: LOCAL_STORAGE_KEY,
    get() {
      return authInfo;
    },
    init(data) {
      init(data);
    },
    initFromLocalStorage() {
      authInfo = JSON.parse(ls.getItem(LOCAL_STORAGE_KEY) || '{}');
    },
    clear() {
      authInfo = {};
      ls.removeItem(LOCAL_STORAGE_KEY);
    },
    save() {
      ls.setItem(LOCAL_STORAGE_KEY, JSON.stringify(authInfo));
    },
    getAccessToken() {
      return authInfo.access_token ? authInfo.access_token : '';
    },
    getUserName() {
      return authInfo.user_name ? authInfo.user_name : '';
    },
    getRolId() {
      return authInfo.rol_id ? authInfo.rol_id : '';
    },
    getUserId() {
      return authInfo.user_id ? authInfo.user_id : '';
    },
    getGroupId() {
      return authInfo.group_id ? authInfo.group_id : '';
    },
    getCompanyId() {
      return authInfo.company_id ? authInfo.company_id : '';
    },
    setCompanyId(companyId) {
      return (authInfo.company_id = companyId);
    },
    getCompanyName() {
      return authInfo.company_name ? authInfo.company_name : '';
    },
    setCompanyName(companyName) {
      return (authInfo.company_name = companyName);
    },
    getTimeZone() {
      return authInfo.time_zone ? authInfo.time_zone : DEFAULT_TIMEZONE;
    },
    getCurrency() {
      return authInfo.currency ? authInfo.currency : DEFAULT_CURRENCY;
    },
    getCompanies() {
      return authInfo.companies ? authInfo.companies : [];
    },
    getGroupCompanies() {
      return authInfo.companiesByGroup ? authInfo.companiesByGroup : [];
    },
    getCreationTime() {
      return authInfo.creation_time;
    },
    getExpirationTime() {
      return authInfo.creation_time + authInfo.expires_in * 1000;
    },
    isExpired() {
      return now() >= this.getExpirationTime();
    },
    isValid() {
      return authInfo && authInfo.access_token && !this.isExpired();
    },
    getTimeToExpire() {
      return this.getExpirationTime() - now();
    },
    expiresInLessThan(ms) {
      const timeToExpire = this.getTimeToExpire();
      return timeToExpire > 0 && ms >= timeToExpire;
    },
    isSuperAdmin() {
      return (
        authInfo &&
        (authInfo.rol_id === 'admin_mdirector' || authInfo.rol_id === 'admin_mdirector_sa')
      );
    },
    isAdminFreemium() {
      return authInfo && authInfo.rol_id === 'adm_mdirector_newfree';
    },
    isAdmin() {
      return authInfo && authInfo.rol_id === 'adm_mdirector';
    },
    isAdm() {
      return this.isAdmin() || this.isAdminFreemium();
    },
    setCompanyData(companyId) {
      var found = this.getGroupCompanies().find(function(cmp) {
        return cmp.id === companyId || !companyId;
      });
      if (found !== undefined) {
        this.setCompanyId(found.id);
        this.setCompanyName(found.name);
        this.save();
      }
    },
  };
};



/** WEBPACK FOOTER **
 ** ./src/info.js
 **/